import { SVGProps, Ref, forwardRef } from 'react';

export const CameraOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m16 2 1.999 3.038C23.198 5.274 24 6.73 24 13v1c0 7-1 8-8 8H8c-7 0-8-1-8-8v-1c0-6.27.802-7.726 6.001-7.962L8 2zM7 6.795 8.97 3.8h6.06L17 6.795l.917.041c2.598.118 3.266.55 3.573.974.19.264.39.725.524 1.606.135.88.186 2.035.186 3.584v1c0 1.736-.065 2.968-.235 3.87-.166.884-.402 1.272-.613 1.482s-.598.447-1.482.613c-.902.17-2.134.235-3.87.235H8c-1.736 0-2.968-.065-3.87-.235-.884-.166-1.272-.402-1.482-.613s-.447-.598-.614-1.482c-.17-.902-.234-2.134-.234-3.87v-1c0-1.55.051-2.703.186-3.584.135-.88.333-1.342.524-1.606.307-.424.975-.856 3.573-.974zM9.8 13c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 14.272 9.8 13.733 9.8 13M8 13c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
CameraOutlinedSize24Glyph.displayName = 'CameraOutlinedSize24Glyph';
